module.exports = __webpack_public_path__ + "dbe7e795a17d6d6adf9d2e8cd6301d99.png";